package app.nestbridge.feature.children.presentation

import app.nestbridge.feature.children.screen.CreateChildProfileScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(CreateChildProfilePresenter::class)
public class CreateChildProfilePresenterFactory(
  private val factory:
      (screen: CreateChildProfileScreen, navigator: Navigator) -> CreateChildProfilePresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is CreateChildProfileScreen -> factory(screen, navigator)
    else -> null
  }
}
